export default __webpack_public_path__ + "f7b07a7f8685097c58339226e2521ed9.png";